<main id="main-content" class="grid nested-grid ">
    <div class="col-12 mt-4 px-6">
        <h1>Search Airman / Operator / Aircraft Registered Owner</h1>
        <div class="p-5 bg-cyan-50 border-300" style="padding-top: 20px !important;">
            <app-searchpanel (searchResults)="handleSearch($event)" searchType="Airman/Operator" (resetPagination) = "handleResetPagination($event)" (isAirmenAgentSearch) = "IsSearchTypeAirmen($event)" [onPageChange]="onPageChange" [sortOrder]="sortOrder" [onAgentDelete]="onAgentDelete"></app-searchpanel>
        </div>
        <div *ngIf="searchResults">
            <app-search-results [searchResults]="searchResults" [isAirmenAgentSearch] = "isAirmenAgentSearch"  [resetPagination]="resetPagination" (pageChange)="handlePageChange($event)" 
            (sortOrderForSearch)="sortOrderForSearch($event)" (agentDelete)="refreshOnAgentDelete($event)"></app-search-results>
        </div>
    </div>
</main>
